module.exports = __webpack_public_path__ + "img/money.5f9e43eb.png";